module.exports = __webpack_public_path__ + "static/media/PA-dark-splash.7849ffdd.jpg";